// File: frontend/src/components/common/SocialFollowBar.js

import React from 'react';
import { FaFacebookF, FaInstagram, FaYoutube, FaTv } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6'; // X (Twitter) ke liye naya icon

// Is file ke styles App.css me daale gaye hain

const SocialFollowBar = () => {
    return (
        <div className="social-follow-bar">
            {/* Yeh aapke social media links hain. 
                "#" ki jagah apne asli URL daalein jab woh taiyaar hon. */}
            
            <a 
                href="https://www.youtube.com/@madhurnews" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-follow-link social-link-tv"
                aria-label="Watch our TV channel"
            >
                <FaTv />
            </a>
            <a 
                href="https://www.facebook.com/people/Madhur-News/61581069557835/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-follow-link social-link-facebook"
                aria-label="Follow us on Facebook"
            >
                <FaFacebookF />
            </a>
            <a 
                href="https://www.youtube.com/@madhurnews" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-follow-link social-link-instagram"
                aria-label="Follow us on Instagram"
            >
                <FaInstagram />
            </a>
            <a 
                href="https://x.com/madhur7766?t=pxSn6xyhdsaC3mr2wCufqA&s=08" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-follow-link social-link-x"
                aria-label="Follow us on X"
            >
                <FaXTwitter />
            </a>
            <a 
                href="https://www.youtube.com/@madhurnews" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-follow-link social-link-youtube"
                aria-label="Subscribe to our YouTube channel"
            >
                <FaYoutube />
            </a>
        </div>
    );
};

export default SocialFollowBar;